export { default } from 'cccisd-game-zoou-avatarbuilder';
